import { Injectable } from '@angular/core';
import { TenantSettingService } from './tenant-setting.service';
import { ITenantSettings, IUpdateTenantSettingsRequest } from '../models/tenant-setting';
import { BehaviorSubject } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { translate } from '@jsverse/transloco';
import { TimeSpan } from 'src/app/shared/helpers/time-span';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class TenantSettingsStoreService {

  constructor(
    private tenantSettingsService: TenantSettingService,
    private appnotificationService: AppNotificationService
    ) { }

  private _tenantSettings$ = new BehaviorSubject<ITenantSettings>(null);
  public tenantSettings$ = this._tenantSettings$.asObservable();

  getCurrentTenantSettings(){
    this.tenantSettingsService.getCurrentTenantSettings()
    .pipe(untilDestroyed(this))
    .subscribe(tenantSettings => {
      this._tenantSettings$.next({
        ...tenantSettings,
        weeklyMaxWorkTimeObj: TimeSpan.parse(tenantSettings.weeklyMaxWorkTime),
        overtimeWeeklyMaxWorkTimeObj: TimeSpan.parse(tenantSettings.overtimeWeeklyMaxWorkTime),
      });
    })
  }

  updateCurrentTenantSettings(request: IUpdateTenantSettingsRequest){
    this.tenantSettingsService.updateTenantSettings(request)
    .pipe(untilDestroyed(this))
    .subscribe(
      (tenantSettings) => {
        this.getCurrentTenantSettings();
        this.appnotificationService.notification$.next(
          {message: translate('tenant-settings.saveSuccess'), style: 'success'}
          )
      })
  }

}
